import { Controller } from '@hotwired/stimulus'

export default class FormController extends Controller {
  static targets = ['form']

  initialize() {
    this.timeout = null;
  }

  submitForm() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      Rails.fire(this.formTarget, 'submit');
    }, 300);
  }

  clearInput(event) {
    const input = document.querySelector(event.currentTarget.dataset.input);
    const option = document.createElement('option');
    option.text = 'Filtrer par';
    option.value = '';

    input.add(option);
    input.value = '';

    const newEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(newEvent);
  }
}
